<epi-container [header]="'Filters'">
    <div class="row">
        <div class="col-sm-10">
            <div class="row">
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Customer Name</strong></label>
                        <input class="form-control input-sm" type="text" [(ngModel)]="nameFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Customer Code</strong></label>
                        <input class="form-control input-sm" type="text" [(ngModel)]="codeFilter" />
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-xs-4">
                    <div class="form-group">
                        <label><strong>Opportunity Owner</strong></label><br />
                        <!--<input type="text" [(ngModel)]="ownerFilter" />-->
                        <kendo-combobox [data]="employees"
                                        [textField]="'fullName'"
                                        [valueField]="'fullName'"
                                        [valuePrimitive]="true"
                                        [placeholder]="''"
                                        [allowCustom]="false"
                                        [(ngModel)]="ownerFilter">
                        </kendo-combobox>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>City</strong></label>
                        <input class="form-control input-sm" type="text" [(ngModel)]="cityFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>State</strong></label>
                        <input class="form-control input-sm" type="text" [(ngModel)]="stateFilter" />
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-xs-4">
                    <div class="form-group">
                        <label><strong>Initiative</strong></label><br />
                        <initiatives-dropdown (selectedInitiativeChanged)="initiativeFilter = $event?.title"></initiatives-dropdown>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Product</strong></label>
                        <input class="form-control input-sm" type="text" [(ngModel)]="productFilter" />
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-xs-4">
                    <div class="form-group">
                        <label><strong>Last Action</strong></label><br />
                        <kendo-datepicker [(ngModel)]="beginActionDate" (valueChange)="dateFilterChange($event)"></kendo-datepicker>
                        <kendo-datepicker [(ngModel)]="endActionDate" (valueChange)="dateFilterChange($event)"></kendo-datepicker>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Days in Cycle</strong></label>
                        <input class="form-control input-sm" type="number" [(ngModel)]="daysFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Estimated Net Revenue</strong></label>
                        <input class="form-control input-sm" type="number" [(ngModel)]="revenueFilter" />
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label><strong>Expected Close</strong></label>
                        <kendo-datepicker [(ngModel)]="beginCloseDate" (valueChange)="closeDateFilterChange($event)"></kendo-datepicker>
                        <kendo-datepicker [(ngModel)]="endCloseDate" (valueChange)="closeDateFilterChange($event)"></kendo-datepicker>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label class="fw-bold">Tags</label>
                        <br />
                        <div class="bg-white overflow-overlay border rounded"
                             style="position:absolute;width:200px;z-index:2;"
                             (click)="isTagListFocus=true"
                             (mouseleave)="isTagListFocus=false"
                             [ngStyle]="isTagListFocus ? {'overflow':'overlay','height':'250px','max-height':'250px'} : {'overflow':'hidden','height':'42px'}">
                            <span class="text-secondary k-float-right m-2"><i class="fas fa-sort-down fa-lg"></i></span>
                            <div *ngIf="tagTypeList.length>0">
                                <div *ngFor="let tag of tagTypeList">
                                    <span class="btn m-1 text-nowrap" [ngClass]="checkSelectedTagType(tag) ? 'btn-' + tag.colorClassName : 'btn-light'" (click)="toggleTagType(tag)">
                                        <i class="fas fa-tag"></i>
                                        {{tag.tagTypePrefix != null && tag.tagTypePrefix != '' ? tag.tagTypePrefix + ' | ' : ''}}
                                        {{tag.tagTypeName}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-2">
            <div class="row">
                <div class="col-sm-12">
                    <button class="epi-button" (click)="filterOpportunities()">Apply Filters</button>
                </div>
                <div class="col-sm-12">
                    <button class="epi-button" (click)="clearFilters()">Clear Filters</button>
                </div>
                <div class="col-sm-12">
                    <button class="epi-button" (click)="addNewOpportunity()">Add Opportunity</button>
                </div>
            </div>
        </div>
    </div>
</epi-container>

<div class="row">
    <div class="col-lg-3">
        <h3 class="text-center">Budget &amp; Quote ({{budgetAndQuotes.length}})</h3>
        <h5 class="text-center">{{budgetRevenue | currency:'USD'}}</h5>

        <div *ngFor="let opp of budgetAndQuotes">
            <div class="crm-card" (click)="openSalesCycleDialog(opp.opportunitySalesCycleMapID)">
                <ul>
                    <li>
                        <!--<h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerName}}</a></h5>
        <h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerCode}}</a></h5>-->
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>{{opp.title}}</label>
                    </li>
                    <li>
                        <label>{{opp.ownerEmployeeName}}</label>
                    </li>
                    <li>
                        <label>Last Action:</label> {{opp.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Expected Close:</label> {{opp.expectedCloseDate | date: 'M/dd/yyyy'}}
                        <span class="badge bg-danger" *ngIf="opp.isPastDue">PAST DUE</span>
                    </li>
                    <li>
                        <label>Start Date:</label> {{opp.startDate | date: 'M/dd/yyyy'}}
                    </li>
                    <li>
                        <label>Est Gross Revenue:</label> {{opp.estimatedGrossRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Net Revenue:</label> {{opp.estimatedRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Annual Order Count:</label> {{opp.estimatedAnnualOrderCount}}
                    </li>
                    <li>
                        <label>Likelihood of Win:</label> {{opp.likelihoodOfWin | percent}}
                    </li>
                    <li>
                        <label>Tags:</label>
                        <span *ngFor="let tag of getTagTypes(opp.tagTypes)">
                            <tagtype-tag [tag]="tag"></tagtype-tag>
                        </span>
                    </li>
                    <!--<li>
        <button class="epi-button" (click)="editOpportunity($event, opp.opportunitySalesCycleMapID)">Edit Opportunity</button>
    </li>-->
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3">
        <h3 class="text-center">Finalist ({{finalists.length}})</h3>
        <h5 class="text-center">{{finalistRevenue | currency:'USD'}}</h5>

        <div *ngFor="let opp of finalists">
            <div class="crm-card" (click)="openSalesCycleDialog(opp.opportunitySalesCycleMapID)">
                <ul>
                    <li>
                        <!--<h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerName}}</a></h5>
        <h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerCode}}</a></h5>-->
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>{{opp.title}}</label>
                    </li>
                    <li>
                        <label>{{opp.ownerEmployeeName}}</label>
                    </li>
                    <li>
                        <label>Last Action:</label> {{opp.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Expected Close:</label> {{opp.expectedCloseDate | date: 'M/dd/yyyy'}}
                        <span class="badge bg-danger" *ngIf="opp.isPastDue">PAST DUE</span>
                    </li>
                    <li>
                        <label>Start Date:</label> {{opp.startDate | date: 'M/dd/yyyy'}}
                    </li>
                    <li>
                        <label>Est Gross Revenue:</label> {{opp.estimatedGrossRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Net Revenue:</label> {{opp.estimatedRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Annual Order Count:</label> {{opp.estimatedAnnualOrderCount}}
                    </li>
                    <li>
                        <label>Likelihood of Win:</label> {{opp.likelihoodOfWin | percent}}
                    </li>
                    <li>
                        <label>Tags:</label>
                        <span *ngFor="let tag of getTagTypes(opp.tagTypes)">
                            <tagtype-tag [tag]="tag"></tagtype-tag>
                        </span>
                    </li>
                    <!--<li>
        <button class="epi-button" (click)="editOpportunity($event, opp.opportunitySalesCycleMapID)">Edit Opportunity</button>
    </li>-->
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3">
        <h3 class="text-center">Pre-Award ({{preAwards.length}})</h3>
        <h5 class="text-center">{{preAwardRevenue | currency:'USD'}}</h5>

        <div *ngFor="let opp of preAwards">
            <div class="crm-card" (click)="openSalesCycleDialog(opp.opportunitySalesCycleMapID)">
                <ul>
                    <li>
                        <!--<h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerName}}</a></h5>
        <h5><a (click)="openCustomerProfile($event, opp.customerCode)">{{opp.customerCode}}</a></h5>-->
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerName}}</a></h5>
                        <h5><a href="/#/customer-detail/{{opp.customerCode}}" target="_blank">{{opp.customerCode}}</a></h5>
                    </li>
                    <li>
                        <label>{{opp.title}}</label>
                    </li>
                    <li>
                        <label>{{opp.ownerEmployeeName}}</label>
                    </li>
                    <li>
                        <label>Last Action:</label> {{opp.maxActionDate | date: 'M/dd/yyyy HH:mm'}}
                    </li>
                    <li>
                        <label>Expected Close:</label> {{opp.expectedCloseDate | date: 'M/dd/yyyy'}}
                        <span class="badge bg-danger" *ngIf="opp.isPastDue">PAST DUE</span>
                    </li>
                    <li>
                        <label>Start Date:</label> {{opp.startDate | date: 'M/dd/yyyy'}}
                    </li>
                    <li>
                        <label>Est Gross Revenue:</label> {{opp.estimatedGrossRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Net Revenue:</label> {{opp.estimatedRevenue | currency:'USD'}}
                    </li>
                    <li>
                        <label>Est Annual Order Count:</label> {{opp.estimatedAnnualOrderCount}}
                    </li>
                    <li>
                        <label>Likelihood of Win:</label> {{opp.likelihoodOfWin | percent}}
                    </li>
                    <li>
                        <label>Tags:</label>
                        <span *ngFor="let tag of getTagTypes(opp.tagTypes)">
                            <tagtype-tag [tag]="tag"></tagtype-tag>
                        </span>
                    </li>
                    <!--<li>
        <button class="epi-button" (click)="editOpportunity($event, opp.opportunitySalesCycleMapID)">Edit Opportunity</button>
    </li>-->
                </ul>
            </div>
        </div>
    </div>

    <div class="col-lg-3">

    </div>
</div>
